import { useAppSelector } from "./redux";
import { isVitalsSubdomain, hasVitalsAIBetaFeature } from "../util/subdomain";

/**
 * Hook to check if the app should be in Vitals AI mode
 * This checks both:
 * 1. If we're on the vitals subdomain (vitals.circadia.link)
 * 2. If the user has the "vitals-ai" beta feature enabled
 *
 * @returns true if either condition is met, false otherwise
 */
export const useVitalsAIMode = (): boolean => {
  const betaFeaturesAllowedList = useAppSelector(
    (state) => state.auth.betaFeaturesAllowedList
  );

  return isVitalsSubdomain() || hasVitalsAIBetaFeature(betaFeaturesAllowedList);
};
